// 过滤 antd Tooltip 相关的弃用警告
const originalWarn = console.warn;

console.error = (...args: any[]) => {
  const message = args[0];

  // 过滤 antd Tooltip 相关的弃用警告
  if (typeof message === 'string' && message.includes('[antd: Tooltip]') && message.includes('is deprecated')) {
    return;
  }

  // 正常输出其他警告
  originalWarn.apply(console, args);
};

export default console.warn;
